import React from 'react';

const badgeStyle = (color) => ({
    display: 'inline-block',
    marginLeft: '0.5rem',
    padding: '0.1rem 0.6rem',
    fontSize: '0.75rem',
    fontWeight: 'normal',
    color: '#fff',
    backgroundColor: color,
    borderRadius: '1rem',
    verticalAlign: 'middle',
});

// Cancelled invoices are flagged by Fortnox and do not count towards turnover
const InvoiceStatusBadge = ({ invoice }) => (invoice.cancelled ? <span style={badgeStyle('#cc4b37')}>Makulerad</span> : null);

export default InvoiceStatusBadge;
